/* @flow */
import * as React from 'react';

import AvatarWithText from 'components/AvatarWithText';
import Organization from 'entities/Organization';
import OrgAvatar from 'organizations/components/OrgAvatar';

type Props = {
  avatar?: React.Element,
  organization: Organization,
};

export default function GroupAvatarWithText({ avatar, organization }: Props) {
  return <AvatarWithText title={organization.getName()} avatar={avatar || <OrgAvatar />} />;
}
